import { FC, Fragment, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { StepperContainer, StepperProgressBar } from './styles'
import { IoMdCheckmark } from 'react-icons/io'

interface StepperProps {
  steps: Array<{
    route: string;
    name: string;
    subroute: Array<string>;
  }>
}

const Stepper: FC<StepperProps> = ({ steps }) => {
  const { pathname } = useLocation()
  const [percentage, setPercentage] = useState<number[]>([])

  const splittedPath = pathname.split('/')
  const route = splittedPath[splittedPath.length - 2]
  const subroute = splittedPath[splittedPath.length - 1]

  useEffect(() => {
    const routeIndex = steps.findIndex(step => step.route === route)

    const lastRouteIndex = steps.length - 1

    setPercentage(steps.map((step, stepIndex) => {
      if(stepIndex < routeIndex) return 100

      if(stepIndex > routeIndex) return 0

      const currentSubStep = (step.subroute.findIndex(sub => sub === subroute) + 1)
      const totalSteps = (step.subroute.length + (stepIndex === lastRouteIndex ? 0 : 1))
      return Math.round((currentSubStep / totalSteps) * 100)
    }))
  }, [route, steps, subroute])

  return (
    <StepperContainer>
      {steps.map((step, index) => (
        <Fragment key={index}>
          <span className={percentage[index] > 0 ? 'progressbar-name-highlighted' : ''}>
            {percentage[index] === 100 ? <IoMdCheckmark /> : null}
            {step.name}
          </span>
          <StepperProgressBar width={percentage[index]}><div></div></StepperProgressBar>
        </Fragment>
      ))}
    </StepperContainer>
  )
}

export default Stepper